export default "__VITE_PUBLIC_ASSET__bc4f3d89__"